import { Banner } from '@/components/ui/banner'
import type { InsuranceApplicationSummary } from '@/models/user'
import { RequoteChangesDialog } from './RequoteChangesDialog'

interface ChangedSinceQuoteBannerProps {
  application: InsuranceApplicationSummary | null | undefined
}

/** Tells staff which carriers priced an older version of this application. */
export function ChangedSinceQuoteBanner({ application }: ChangedSinceQuoteBannerProps) {
  const vendors = application?.outOfDateVendors ?? []
  if (!vendors.length || !application?.hasDispatchedIndications) return null

  const changes = application.requoteChanges ?? []

  return (
    <Banner
      variant="warning"
      small
      action={changes.length > 0 ? <RequoteChangesDialog changes={changes} /> : undefined}
    >
      These carriers priced an older version of this application: {vendors.join(', ')}. Resubmit them, or use
      Requote to send it to every carrier.
    </Banner>
  )
}
